<template>
<div id="it1024im" style="height: 100%;">
    <!-- 头部组件 -->
    <!-- <component :is="header_"></component> -->
    
    <div class="it1024im">
    <!--  -->
    <el-container class="el-container-box" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <!-- <component :is="celan"></component> -->
      

      <!-- 主体 -->
      <el-main>
      <div id="container">
        <div class="it1024im-header">
          <div>IM</div>
        </div>
        <div class="it1024im-section" style="background: #ebebeb;">
          <div>
              <ul>
                <li>
                 <span>
                   <img :src="it1024imURL+'/php/upimg/it1024im-kefuimg.png'" alt="">
                 </span>
                 <input type="text" placeholder="客服">
                 <span><el-button type="success" icon="el-icon-check" circle></el-button></span>
                </li>
                <li>
                 <span>
                   <img :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'" alt="">
                 </span>
                 <input type="text" placeholder="访客">
                 <span><el-button type="success" icon="el-icon-check" circle></el-button></span>
                </li>
              </ul>
          </div>
        </div>
        <div class="it1024im-footer">
            <!-- 底部导航 -->
            <ul class="footer-tab">
              <li>
               <router-link to='/mobile'>
                <i class="el-icon-chat-square"></i>
                <span>消息</span>
               </router-link>
              </li>
              <li>
               <router-link to='/setting'>
                <i class="el-icon-s-custom"></i>
                <span>我的</span>
               </router-link>
              </li>
            </ul>
        </div>
      </div>    
        
      </el-main>

    </el-container>
    </div>

</div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
//头部组件
import header_ from './header_.vue'    
import celan from './celan.vue'    
export default {
    name: 'it1024im',
    data() {
      return {
        header_: header_,
        celan: celan,
        textarea_val: '',
        it1024im:[],
        it1024im_id:[],
        userid_number:[],
        ImUserid:'',
        it1024imURL: global.it1024imURL,
        posturl: global.it1024imUrl,
      }
    },
    methods: {
      
    },
    mounted() {

    }
  }
</script>


<style scoped>
*{ 
  margin:0;
  padding: 0;
}
html,body {
    width: 100%;
    height: 100%;
}
ul{
    list-style-type: none
}
a:link{
  text-decoration: none;
}
.el-container-box,#it1024im,.it1024im {
    width: 100%;
    height: 100%;
}

/*@media screen and (max-width: 800px) {

}*/

.it1024im-Unread-messages {
    background: #ff4444;
    color: #fff;
    font-size: 12px;
    border-radius: 53%;
    width: 1.5rem;
    display: inline-block;
    text-align: center;
    overflow: hidden;
    float: right;
    margin-top: 8px;
}
.it1024im-window-textarea{
      -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    height: 40px;
    padding-left: 5px;
    border: 0;
    background-color: #fff;
    border-radius: 3px;
}
.it1024im-window-button{
    border-radius: 3px;
    height: 40px;
    padding: 0 20px;
    border: 0;
    margin-left: 10px;
    background-color: #5FB878;
    color: #fff;
}




.it1024im-chat-footer {
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: baseline;
}



.it1024im-section ul li {
background: #ffffff;
    cursor: pointer;
    border-bottom: 1px solid #f2f2f2;
    height: 3rem;
    line-height: 3rem;
    padding: 0 10px 0 10px;
    font-size: 17px;
        display: flex;
    justify-content: space-between;
    text-align: center;
    -webkit-box-align: baseline;
}
.it1024im-section ul li input{
    width: 63%;
    border: none;
    outline: none;
}
.it1024im-section ul li img{
    vertical-align: middle;
    border-style: none;
    width: 38px;
    border-radius: 50%;
}
.el-button.is-circle {
    border-radius: 50%;
    padding: 5px;
    height: 26px;
    outline: none;
}
#container {
    display: flex;
    height: 100%;
    flex-direction: column;
}
.it1024im-header {
    background: #6793e0;
    width: 100%;
    z-index: 99;
    height: 3rem;
    line-height: 3rem;
    font-size: 1.3rem;
    padding-left: 0.5rem;
    color: white;
    font-weight: bold;
}
.it1024im-section {
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow: auto;
    -moz-overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.it1024im-footer {
    width: 100%;
    background: #ffffff;
    height: 3.5rem;
}
.it1024im-footer ul {
    display: flex;
    justify-content: space-around;
    text-align: center;
    align-items: baseline;
}

.footer-tab li{
    line-height: 19px;
    padding-top: 1px;
}
.footer-tab li:nth-child(1) i, .footer-tab li:nth-child(1) span{
    color: #7b7b7b;
}
.footer-tab li:nth-child(2) i, .footer-tab li:nth-child(2) span{
    color: #6793e0;
}
.footer-tab span{
    display: block;
    font-size: 13px;
}
.footer-tab i{
    font-size: 1.6rem;
}



</style>


// WEBPACK FOOTER //
// src/components/setting.vue